import doubleDigitize from 'src/filters/doubleDigitize';
import i18n from 'src/features/i18n';

function secondsToHms(seconds) {
  const interval = parseInt(seconds, 10);

  const sign = interval >= 0 ? '' : '-';
  const d = Math.abs(Math.floor(interval / (24 * 3600)));
  const h = Math.abs(Math.floor((interval / 3600) % 24));
  const m = Math.abs(Math.floor((interval / 60) % 60));
  const s = Math.abs(Math.floor(interval % 3600 % 60));
  const days = d > 0 ? `${doubleDigitize(d)}${i18n.t('T_DAYS')} ` : '';

  return `${days}${sign}${doubleDigitize(h)}:${doubleDigitize(m)}:${doubleDigitize(s)}`;
}

export default secondsToHms;
